// @ts-nocheck legacy file transformed to TS
import path from 'path'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Promise from 'bluebird'
import { withFormik } from 'formik'
import { Button } from 'ic-snacks'
import styled from '@emotion/styled'
import zipObject from 'lodash/zipObject'
import isEqual from 'lodash/isEqual'
import Modal from 'legacy/components/Modal'
import instacart from 'legacy/common/instacart'
import { errors } from 'utils/error-handling/errors'
import withRetailerRouter from 'legacy/common/withRouter'

const formProps = {
  style: {
    display: 'flex',
    flex: '1',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    padding: '25px',
    width: '100%',
  },
}

const InlineContainer = styled.div`
  width: 100%;
`

const Footer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 0 0px;
`

const buttonStyle = {
  width: '140px',
  justifyContent: 'center',
  marginRight: '10px',
}

function withForm({
  inline,
  title,
  width,
  height,
  resource,
  asyncData,
  onCreate,
  onUpdate,
  onSuccess,
  onError,
  onClose,
  componentDidMount,
  ...others
}) {
  return function form(FormView) {
    @withRetailerRouter
    class Form extends Component {
      state = {
        isAsyncDataLoaded: false,
        asyncData: {},
      }

      onClose = () => {
        if (this.props.dirty && !global.confirm('Are you sure you want to discard all changes?')) {
          return
        }
        if (this.props.isSubmitting) return
        if (onClose) return onClose(this.props)
        this.props.history.goBack()
      }

      componentDidMount() {
        if (this.props.asyncData && Object.keys(this.props.asyncData).length) {
          Promise.all(Object.values(this.props.asyncData).map(fn => fn(this.props))).spread(
            (...asyncDataResults) => {
              this.setState({
                asyncData: zipObject(Object.keys(this.props.asyncData), asyncDataResults),
                isAsyncDataLoaded: true,
              })
            }
          )
        } else {
          this.setState({
            isAsyncDataLoaded: true,
          })
        }
        componentDidMount && componentDidMount.call(this)
      }

      componentDidUpdate(prevProps) {
        const previousQuery = prevProps.query
        const { query } = this.props
        if (
          !isEqual(prevProps.initialValues, this.props.initialValues) ||
          previousQuery['reset-form'] !== query['reset-form']
        ) {
          this.props.resetForm()
        }
      }

      renderHeader() {
        return typeof title === 'function' ? title(this.props) : title
      }

      renderBody() {
        if (!this.state.isAsyncDataLoaded) return null

        return <FormView {...this.props} formProps={formProps} asyncData={this.state.asyncData} />
      }

      renderFooter() {
        if (inline) return null

        return (
          <Footer>
            <Button
              elementAttributes={{
                'data-cy': 'close-form',
              }}
              onClick={this.onClose}
              style={buttonStyle}
              disabled={this.props.isSubmitting}
              snacksStyle="secondary"
            >
              Cancel
            </Button>
            <Button
              elementAttributes={{
                'data-cy': 'submit-form',
              }}
              onClick={this.props.submitForm}
              style={buttonStyle}
              disabled={this.props.isSubmitting}
              snacksStyle="primary"
            >
              Save
            </Button>
          </Footer>
        )
      }

      render() {
        if (inline) {
          return (
            <InlineContainer>
              {this.renderBody()}
              {this.renderFooter()}
            </InlineContainer>
          )
        }

        return (
          <Modal height={height} width={width} onClose={this.onClose}>
            {(ModalHeader, ModalBody, ModalFooter) => [
              <ModalHeader>{this.renderHeader()}</ModalHeader>,
              <ModalBody>{this.renderBody()}</ModalBody>,
              <ModalFooter>{this.renderFooter()}</ModalFooter>,
            ]}
          </Modal>
        )
      }
    }

    const WithFormComponent = withFormik({
      ...others,
      enableReinitialize: true,
      async handleSubmit(values, { props, setSubmitting, setErrors }) {
        try {
          setSubmitting(true)
          if (resource && typeof resource === 'string') {
            if (props.id) {
              await instacart.go.put(path.join(resource, props.id), {
                data: values,
              })
            } else {
              await instacart.go.post(resource, { data: values })
            }
          } else if (typeof onUpdate === 'function' && props.id) {
            await onUpdate(values, props)
          } else if (typeof onCreate === 'function') {
            await onCreate(values, props)
          } else {
            throw new Error('No valid submit handler found.')
          }
          if (!onSuccess) {
            throw new Error('Success callback required')
          }
          // SEE: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/length
          if (onSuccess.length === 2) {
            onSuccess(values, props)
          } else {
            onSuccess(props)
          }
        } catch (e) {
          if (e.errors) {
            setErrors({
              server: e.errors.toString(),
            })
            onError && onError(e.errors.toString(), props, setErrors)
          } else {
            errors.captureException(e)
            setErrors({
              server: e.status,
            })
          }
        } finally {
          setSubmitting(false)
        }
      },
    })(props => <Form {...props} asyncData={asyncData} />)

    WithFormComponent.propTypes = {
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      initialValues: PropTypes.object,
    }

    WithFormComponent.defaultProps = {
      id: null,
      initialValues: null,
    }

    return WithFormComponent
  }
}

export default withForm
